export enum SmeLanguage {
  EN = 'EN', // English,
  BG = 'BG', // български,
  CS = 'CS', // čeština,
  DA = 'DA', // dansk,
  DE = 'DE', // Deutsch,
  ET = 'ET', // eesti keel,
  EL = 'EL', // ελληνικά,
  ES = 'ES', // español,
  FR = 'FR', // français,
  IT = 'IT', // italiano,
  LV = 'LV', // latviešu valoda,
  LT = 'LT', // lietuvių kalba,
  HU = 'HU', // magyar,
  MT = 'MT', // Malti,
  NL = 'NL', // Nederlands,
  PL = 'PL', // polski,
  PT = 'PT', // português,
  RO = 'RO', // română,
  SK = 'SK', // slovenčina,
  SL = 'SL', // slovenščina,
  FI = 'FI', // suomi,
  SV = 'SV', // svenska,
  HE = 'HE', // עִבְרִית,
  HR = 'HR', // hrvatski,
  IS = 'IS', // íslenska,
  MK = 'MK', // Македонски,
  CNR = 'CNR', // Црногорски,
  NO = 'NO', // norsk,
  SR = 'SR', // Српски,
  SQ = 'SQ', // Shqip,
  TR = 'TR', // Türkçe,
}
